import Context from './Context.js';

export default class OnlineSales2 extends Context {
  constructor(step, previousStep, entryPoint, paymentMethod, extrasList, extrasValue, deliveryMethod, deliveryValue, provider, option, seen, usedForQuote)  {
    super();
    this.data = {
      ovs: {
        step: step,
        previous_step: previousStep,
        entry_point: entryPoint
      },
      payment_method: paymentMethod,
      extras: {
        list: extrasList,
        value: extrasValue
      },
      delivery: {
        method: deliveryMethod,
        value: deliveryValue
      },
      provider: provider,
      option: option,
      part_exchange: {
        seen: seen,
        used_for_quote: usedForQuote
      }
    };
  }

  static get key() {
    return 'online_sales_event_context'
  }

  static get version() {
    return '2-1-0';
  }
}
